interface DownloadAndFileInstructionsProps {
  formType: '1095-B' | '1095-C'
}

export default function DownloadAndFileInstructions ({ formType }: DownloadAndFileInstructionsProps) {
  return (
    <div className='space-y-6'>
      <div>
        <h3 className='text-lg text-gray-800 mb-2'>
          Download your {formType} data
        </h3>
        <p className='text-sm text-gray-600'>
          You can download your {formType} data from the <a href='/employers/documents' className='text-thatch-600 underline'>Documents</a> page.
        </p>
      </div>

      <div>
        <h3 className='text-lg text-gray-800 mb-2'>
          File your {formType} with the IRS
        </h3>
        <p className='text-sm text-gray-600'>
          If you have questions about filing your {formType}, consult your HR team, legal counsel, or tax advisor.
        </p>
      </div>
    </div>
  )
}
